import { Injectable } from '@angular/core';
import { DataTableEditorService } from '../../../../../shared/search/results/data-table-editor.service';

@Injectable()
export class DockDoorBookingKeyEventHandlerService {

  // To identify and ignore focusin events from mouseclick
  public focusedProperty: string;
  // To identify and ignore focusin events from mouseclick
  public clickFocusedCellId: string;
  // To ignore false keypress/focusout call triggers
  public lastEditKeyPressListnerInvocationTime: number = 0;

  // Editor Service for Data Table
  constructor(public tableEditor: DataTableEditorService) { }

  // Function called on focusin events(click/tab) to set focusedcell/rowid
  public setFocusedCell(row: any, property: any) {
    this.focusedProperty = property;
    this.clickFocusedCellId = property;
    // this.lastFocusedCellProperty = property;
  }

  /* Function that is listened by directive set-focus to focus the cell based on
    this.lastFocusedRowIndex & row.focusedCellId
    row.focusedCellId can be set from any external functions like from table-editor service etc.
    Also it ensures that no false trigger happens due to (focusin)
    events using mouse or any other interaction(uses this.clickFocusedCellId). */
  public isFocused(row: any, colProp: any) {
    if (colProp === row.focusedCellId && colProp !== this.clickFocusedCellId) {
      return true;
    } else {
      return false;
    }
  }

  public propertyFocusedOut(cells: any, property: any) {
    const row = { cells: cells };
    if (cells[property] && cells[property].isEdited === true) {
      this.tableEditor.autoPopulateLookupProperty(row, property, this);
      return false;
    }
    return true;
  }

  /* Function that listens to Enter/Tab keypress on input fields in edit mode
  and calls respective functions in case of EA fields*/
  public editKeyPressListner(event: any, cells: any, columnMeta: any) {
    if (!(event.keyCode === 13 || event.keyCode === 9 || event.type === 'focusout')) {
      // ignore if not ENTER13 OR Tab9.
      return true;
    }
    // tslint:disable-next-line:max-line-lengthif()
    const cell = cells[columnMeta.propertyName];
    if (!cell) {
      return true;
    }
    if ((!cell.cVal) || (cell.cVal === cell.cValPrev)) {
      if (event.keyCode === 9 && cell.isValueInvalid) {
        this.clickFocusedCellId = '';
        this.focusedProperty = columnMeta.propertyName;
        // if cell has invalid value and tab is pressed. prevent the tab click.
        return false;
      }
      // ignore if no change in value
      return true;
    }

    const invocationTime = new Date();
    if ((invocationTime.getTime() - this.lastEditKeyPressListnerInvocationTime) < 300) {
      // return if last event with 300ms
      this.lastEditKeyPressListnerInvocationTime = invocationTime.getTime();
      return true;
    }

    /* clickFocusedCellId needs to be cleared,
      since when both are same manual focus wont get triggered. */
    this.clickFocusedCellId = '';
    // this.lastEditKeyPressListnerInvocationTime = invocationTime.getTime();
    // Set prev value. For dependent columns update within each function
    cells[columnMeta.propertyName].cValPrev = cells[columnMeta.propertyName].cVal;
    const row = { cells: cells };
    switch (columnMeta.displayType) {
      case 'EA':
        this.tableEditor.autoPopulate(row, columnMeta.propertyName);
        return false;
      case 'EL':
        this.tableEditor.autoPopulateLookupProperty(row, columnMeta.propertyName, this);
        return false;
      case 'L':
        this.tableEditor.autoPopulateLookupProperty(row, columnMeta.propertyName, this);
        return false;
      default:
        return true;
    }
  }

  public focusOutListener(cell: any){
    this.tableEditor.focusOutListener(cell);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/dock-door-booking/dock-door-booking-home/services/dock-door-booking-key-event-handler.service.ts